import { Injectable } from '@angular/core';
import { Plugins } from '@capacitor/core';
const { Device } = Plugins;

@Injectable(
  {providedIn: 'root'}
)
export class ContextService {

  onMobileOS= false;

  constructor() {
    // console.log('construct context service');
    Device.getInfo().then(info => {
      this.onMobileOS = (info.platform == 'ios' || info.platform == 'android');
      console.log(info.platform);
    });
  }

  init(){
  }
}
